import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { logisticsSelectList, closeCasedocumentListColumns } from '../utils';
import { mailingDetail, claimsClosed } from '../request';
export default {
  props: {
    claimsId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      closeCasedocumentListColumns,
      logisticsSelectList,
      previewVisible: false,
      dataFrom: {
        result: undefined
      },
      mailingDetail: {},
      id: '',
      isBtnShow: false
    };
  },
  created() {
    setTimeout(() => {
      this.init();
    }, 400);
  },
  computed: {
    dataRule() {
      return {
        result: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('理赔结果')
        }]
      };
    },
    closeCaseRule() {
      return {
        result: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('理赔结果')
        }],
        remark: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('原因')
        }]
      };
    },
    closeCaseRule2() {
      return {
        result: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('理赔结果')
        }],
        amount: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('赔付金额')
        }],
        payoutAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('赔付时间')
        }],
        isBack: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('是否需要物理件回寄')
        }],
        logisticsCompany: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('物流公司')
        }],
        shipmentNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('运单号')
        }],
        documentList: [{
          required: true,
          validator: this.validateList,
          type: 'array'
        }]
      };
    }
  },
  methods: {
    validateList(rule, value, callback) {
      console.log(this.dataFrom.documentList);
      if (!this.dataFrom.documentList || this.dataFrom.documentList.length == 0) {
        callback(new Error(this.$t('至少选择一项资料')));
      } else {
        callback();
      }
    },
    async init() {
      this.id = this.claimsId;
      const res = await mailingDetail({
        claimsId: this.id
      });
      if (res) {
        this.mailingDetail = res;
      } else {
        this.dataFrom.isBack = 0;
      }
      this.isBtnShow = res ? true : false;
      // this.previewVisible=true;
    },
    resultChange() {
      this.dataFrom = {
        result: this.dataFrom.result,
        isBack: this.dataFrom.isBack
      };
      if (this.dataFrom.result == 1 && !this.mailingDetail) {
        this.dataFrom.isBack = 0;
      }
      console.log(this.dataFrom);
      this.$refs.dataFrom.resetFields();
      if (this.dataFrom.result == 2) {
        this.dataRule = this.closeCaseRule;
      } else {
        this.dataRule = this.closeCaseRule2;
      }
    },
    mailChange(index) {
      this.mailingDetail.list[index].isChecked = !this.mailingDetail.list[index].isChecked;
      console.log(this.mailingDetail, 22);
      this.dataFrom.documentList = [];
      this.mailingDetail.list.map(item => {
        console.log(item, 223);
        if (item.isChecked) {
          this.dataFrom.documentList.push({
            documentId: item.documentId,
            documentName: item.documentName,
            remark: item.remark
          });
        }
      });
      console.log(this.dataFrom.documentList);
    },
    handleSure() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          this.dataFrom.claimsId = this.id;
          this.dataFrom.documentList = JSON.stringify(this.dataFrom.documentList);
          console.log(this.dataFrom);
          await claimsClosed(this.dataFrom);
          this.$message.success(this.$t('操作成功'));
          this.$emit('ok');
          this.$emit('cancel');
        }
      });
    }
  }
};